"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basketMutations = exports.basketMutationKeys = void 0;
const basket_api_1 = require("./basket.api");
exports.basketMutationKeys = {
    all: () => ['basket'],
    postSavePoint: () => [...exports.basketMutationKeys.all(), 'postSavePoint'],
};
const basketMutations = (apiOptions) => ({
    postSavePoint: {
        mutationKey: exports.basketMutationKeys.postSavePoint(),
        mutationFn: () => (0, basket_api_1.postSavePoint)(apiOptions),
    },
});
exports.basketMutations = basketMutations;
//# sourceMappingURL=basket.mutations.js.map